import { apiCommon, apiTypes } from 'ui/api'
import { IRequestState } from 'ui/api/requestState'

export const createTmsServiceConfig = async (): Promise<
	IRequestState<apiTypes.TmsServiceConfigResponse>
> => {
	const url = `companies/tms-service-config`
	return apiCommon.apiFetch<apiTypes.TmsServiceConfigResponse>(
		() => {},
		{
			method: 'POST',
		},
		url,
	)
}

export const getTmsServiceConfig = async (): Promise<
	IRequestState<apiTypes.TmsServiceConfigResponse>
> => {
	const url = `companies/tms-service-config`
	return apiCommon.apiFetch<apiTypes.TmsServiceConfigResponse>(
		() => {},
		{
			method: 'GET',
		},
		url,
	)
}

export const updateTmsServiceConfig = async (
	data: apiTypes.TmsServiceConfigRequest,
): Promise<IRequestState<apiTypes.TmsServiceConfigResponse>> => {
	const url = `companies/tms-service-config`
	return apiCommon.apiFetch<apiTypes.TmsServiceConfigResponse>(
		() => {},
		{
			method: 'PUT',
			data,
		},
		url,
	)
}

export const deleteTmsServiceConfig = async (): Promise<
	IRequestState<apiTypes.TmsServiceConfigResponse>
> => {
	const url = `companies/tms-service-config`
	return apiCommon.apiFetch<apiTypes.TmsServiceConfigResponse>(
		() => {},
		{
			method: 'DELETE',
		},
		url,
	)
}

export const getAutoGeneratedProviderCode = async (): Promise<
	IRequestState<string>
> => {
	const url = `companies/tms-service-config/autoGenerateProviderCode`
	return apiCommon.apiFetch<string>(
		() => {},
		{
			method: 'GET',
		},
		url,
	)
}
